import { commonComponents as cc } from "@/components/common";
import { cn } from "@/lib/utils";
import { ui } from "@patient-watch/ui";
import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import type { ReactNode } from "react";

interface ProfileCalloutProps {
    title: string;
    description?: ReactNode;
    icon?: ReactNode;
    children?: ReactNode;
    actionLabel: string;
    /** Navigate via TanStack Router when set. */
    actionTo?: string;
    /** Click handler when not using `actionTo`. */
    onAction?: () => void;
    className?: string;
}

/**
 * Shared profile-page callout: same layout as Profile Incomplete
 * (indigo Call + description + primary action with arrow).
 */
const ProfileCallout = ({
    title,
    description,
    icon,
    children,
    actionLabel,
    actionTo,
    onAction,
    className,
}: ProfileCalloutProps) => {
    const actionContent = (
        <>
            {actionLabel}
            <ArrowRight size={20} strokeWidth={2.5} className="group-hover:translate-x-0.5 duration-300 ease-in-out" />
        </>
    );

    const button = actionTo ? (
        <ui.Button size="md" asChild className="group">
            <Link to={actionTo}>{actionContent}</Link>
        </ui.Button>
    ) : (
        <ui.Button size="md" type="button" className="group" onClick={onAction}>
            {actionContent}
        </ui.Button>
    );

    return (
        <cc.Call className={cn("mb-4", className)} words={title} icon={icon} button={button}>
            {description != null && description !== "" ? <p>{description}</p> : null}
            {children}
        </cc.Call>
    );
};

export default ProfileCallout;
